export default __webpack_public_path__ + "static/media/Right line.42ded84e.svg";